//################################################## //
//###### PLUGINS ################################### //
//################################################## //

class VideoResponser {
  constructor(selector) {
    const $video = document.querySelector(selector);
    this.options = { 
      selector, 
      breakpoints: { default: { src: $video.getAttribute('data-src') } } 
    };

    $video.querySelectorAll('[data-src]').forEach(element => this.options.breakpoints[element.getAttribute('data-from-breakpoint')] = { src: element.getAttribute('data-src') });
    $video.innerHTML = '';
      
    this.responseVideo(this.options);
    this.resizer();
  }

  resizer() {
    window.addEventListener("resize", () => this.responseVideo(this.options));
  }

  responseVideo(options) {
    const {selector, breakpoints} = options;
    let $video = document.querySelector(selector);
    const widthNow = $video.getAttribute('data-width-now') || null;
    const maxBreakpoint = Math.max(Object.keys(breakpoints).filter(key => key >= document.body.clientWidth));
    const nowBreakpoint = maxBreakpoint || 'default';

    if(widthNow && widthNow == nowBreakpoint) return;

    $video.setAttribute('data-width-now', nowBreakpoint);
    $video.src = breakpoints[nowBreakpoint].src;
  }
}

( function ( $ ) {
	// ############################################# //
	// Enable cache for AJAX-requests #############  //
	// ############################################# //
	$.ajaxSetup( {
		cache: true
	} );

	$( function () {
		var leistungenVideo = '#leistungen-video';

		if (document.querySelector(leistungenVideo)) {
			new VideoResponser(leistungenVideo);

			$(window).on('scroll', function() {
				if ($(leistungenVideo).is(":in-viewport")) {
					var leistungenVideoDelay = (typeof $(leistungenVideo).attr('data-delay') !== 'undefined' && $(leistungenVideo).attr('data-delay') !== false ? $(leistungenVideo).attr('data-delay') : 1000);

					if ($(leistungenVideo)[0].currentTime == 0) {
						setTimeout(function() {
							$(leistungenVideo)[0].play();
						}, leistungenVideoDelay);
					}
				}
			});
		}

		// ############################################# //
		// STICKY ELEMENT ############################## //
		// ############################################# //
		$( '.team .col-md-4, .form .col-md-5, .serviceuebersicht .col-md-4, .txt-box-modul .col-md-4, .locations-filter-places .col-md-4.right, .stick-box' )
			.stickit( {
				top: 120,
			} );


		// ############################################# //
		// ANIMATED #################################### //
		// ############################################# //
		var wow = new WOW(
			{
				boxClass: 'wow',
				animateClass: 'animated',
				offset: 0,
				mobile: true,
				live: true,
				scrollContainer: null
			}
		);
		wow.init();


		// ############################################# //
		// PLACEHOLDER FIX ############################# //
		// ############################################# //
		$( 'input, textarea' ).placeholder();

		$('.carousel').carousel();

		// ############################################# //
		// OWL CAROUSEL ################################ //
		// ############################################# //
		/* var homeCarousel = $( '.home .carousel' ),
			homeCarouselAutoplay = homeCarousel.data('autoplay'),
			homeCarouselLoop = homeCarousel.data('loop'),
			homeCarouselAutoplayTimeout = homeCarousel.data('interval');

  	homeCarousel.owlCarousel( {
			autoplay: homeCarouselAutoplay,
			autoplayTimeout: homeCarouselAutoplayTimeout,
			loop: homeCarouselLoop,
			margin: 0,
			nav: false,
			smartSpeed: 800,
			mouseDrag: false,
			touchDrag: true,
			responsive: {
				0: {
					items: 1
				},
				600: {
					items: 1
				},
				1000: {
					items: 1
				}
			}
		} );

		var mainCarousel = $( '.carousel' ),
			mainCarouselAutoplay = mainCarousel.data('autoplay'),
			mainCarouselLoop = mainCarousel.data('loop'),
			mainCarouselAutoplayTimeout = mainCarousel.data('interval');

	  mainCarousel.owlCarousel( {
			autoplay: mainCarouselAutoplay,
			autoplayTimeout: mainCarouselAutoplayTimeout,
			loop: mainCarouselLoop,
			margin: 0,
			nav: false,
			smartSpeed: 800,
			mouseDrag: false,
			touchDrag: false,
			responsive: {
				0: {
					items: 1
				},
				600: {
					items: 1
				},
				1000: {
					items: 1
				}
			}
		} ); */


		// ############################################# //
		// SLICK CAROUSEL ############################## //
		// ############################################# //
		$( '.objektansicht-carousel' ).slick( {
			centerMode: true,
			centerPadding: '300px',
			slidesToShow: 1,
			arrows: false,
			dots: true,
			adaptiveHeight: true,
			responsive: [
				{
					breakpoint: 1199,
					settings: {
						centerMode: true,
						centerPadding: '150px',
						slidesToShow: 1
					}
				},
				{
					breakpoint: 768,
					settings: {
						centerMode: true,
						centerPadding: '40px',
						slidesToShow: 1
					}
				},
				{
					breakpoint: 480,
					settings: {
						centerMode: false,
						slidesToShow: 1
					}
				}
			]
		} );


		// ############################################# //
		// MAGNIFIC POPUP ############################## //
		// ############################################# //
        $( '.open-popup-link' ).each(function(index) {
            var contactBox = $($(this).closest( 'section' ).siblings( '#kontaktbox' )[0]);

            $(this).attr("href", "#open-" + index);
            contactBox.attr( 'id', 'open-' + index );
        });

		$( '.open-popup-link, .open-modal' ).magnificPopup( {
			type: 'inline',
			midClick: true,
			closeBtnInside: true,
			mainClass: 'mfp-fade',
		} );


		// ############################################# //
		// MIXITUP PLUGIN ############################## //
		// ############################################# //
		var containerEl = document.querySelector( '.locations-filter' );
		var mixer;
		if ( containerEl ) {
			mixer = mixitup( containerEl, {} );
		}


		// ############################################# //
		// ISOTOPE PLUGIN ############################## //
		// ############################################# //
		var $gridnews = $('.grid-news').masonry({
			itemSelector: '.grid-item',
			layoutMode: 'masonry',
			masonry: {
				columnWidth: 0
			}
		});
		$gridnews.imagesLoaded().progress( function() {
			$gridnews.masonry('layout');
		});

		window.setTimeout(function () {
			$('.grid-themen').isotope({
				itemSelector: '.grid-item',
				layoutMode: 'masonry',
				masonry: {
					columnWidth: 1
				}
			});

			$('.grid-archive').isotope({
				itemSelector: '.grid-item',
				layoutMode: 'masonry',
				masonry: {
					columnWidth: 1
				}
			});
		}, 100);


		// var $gridthemen = $('.grid-themen').masonry({
		//   	itemSelector: '.grid-item',
		//   	percentPosition: true,
		//   	layoutMode: 'masonry',
		// 	masonry: {
		// 		columnWidth: '.grid-sizer',
		// 		rowHeight: 230
		// 	}
		// });
		// $gridthemen.imagesLoaded().progress( function() {
		//   $gridthemen.masonry('layout');
		// });

// 	var $container = $('.grid-themen')
// // initialize Isotope
// $container.isotope({
//   // options...
//   resizable: false, // disable normal resizing
//   // set columnWidth to a percentage of container width
//   masonry: { columnWidth: $container.width() / 2 }
// });

// $container.imagesLoaded().progress( function() {
// 	  $container.masonry('layout');
// 	});



		var $gridstart = $('.grid-news-start').masonry({
			itemSelector: '.grid-item',
			layoutMode: 'masonry',
			masonry: {
				columnWidth: 0
			}
		});
		$gridstart.imagesLoaded().progress( function() {
			$gridstart.masonry('layout');
		});


		// ############################################# //
		// MENU PLUGIN ################################# //
		// ############################################# //
		var $menu = $( "#menu" ).mmenu( {
			// options:
			slidingSubmenus: false,
			navbar: false,
			extensions: [
				"position-right",
				"pagedim-black"
			]
		}, {
			// configuration:
			clone: true,
			classNames: {
				fixedElements: {
					fixed: "fix"
				}
			}
		} );
		var api = $menu.data( "mmenu" );
		api.bind( "open:start", function () {
			$( '.hamburger' ).addClass( 'is-active' );
		} );
		api.bind( "close:start", function () {
			$( '.hamburger' ).removeClass( 'is-active' );
		} );


		// ############################################# //
		// OWN FUNCTIONS ############################### //
		// ############################################# //

		// Header scroll function
		var $header = $( "header" ),
			$clone = $header.before( $header.clone().addClass( "clone" ) );

		$( window ).scroll( function () {
			var scroll = $( window ).scrollTop();
			if ( scroll >= 130 ) {
				$( "body" ).addClass( "colored" );
			} else {
				$( "body" ).removeClass( "colored" );
			}
		} );

		// Header arrow scroll to ID
		$( ".scroll-down img" ).click( function () {
			$( "html, body" ).animate( {
				scrollTop: $( '#main-content' ).offset().top - 60
			}, 1000 );
		} );

		// Hamburger active state
		$( ".hamburger" ).click( function () {
			api.open();
		} );

		$( '.hamburger' ).click( function ( event ) {
			event.stopPropagation();
		} );

		// Search active state
		$( ".search-ico" ).click( function () {
			$( '.search-input' ).addClass( 'is-active' );

			window.setTimeout(function () {
				if ( $( "body" ).hasClass( 'home' ) && $( "body" ).hasClass( 'colored' ) ) {
					$( 'header.clone' ).find( 'input[type="search"]' ).focus();
				} else {
					$( 'header:not(.clone)' ).find( 'input[type="search"]' ).focus();
				}
			}, 100);
		} );

		$( ".search-close" ).click( function () {
			$( '.search-input' ).removeClass( 'is-active' );
		} );

		$( ".reset-val" ).click( function () {
			$( '.search-field-input input' ).val( "" );
		} );

		// Back to top button
		$( '.backtotop' ).click( function () {
			$( 'body,html' ).animate( {
				scrollTop: 0
			}, 1000 );
		} );

		// Anchor navigation
		$( '.anchor-navigation' ).on( 'click', '.links a[href^="#"]', function ( event ) {
			var $link = $( event.currentTarget ),
				$target = $( $link.attr( 'href' ) );

			if ( 0 < $target.length ) {
				event.preventDefault();

				$link.blur();
				$( 'body,html' ).animate( {
					scrollTop: $target.offset().top - 60,
				}, 1000 );
			}
		} );

		$( 'input' ).bind( 'focusin focus', function ( e ) {
			e.preventDefault();
		} )

		$('table').wrap('<div class="table-wrap"></div>');

		$( '.counter-up:visible' ).counterUp( {
			time: 2000,
			formatter: numberFormatter
		} );

		$( '.keyfacts-modul' ).each( function () {
			var $container = $( this ),
				$factsSlider = null,
				$factsContainer = $container.find( '.facts-container' ),
				$factRows = $container.find( '.facts' ),
				$moreLink = $container.find( '.load-more' ),
				isSlider = false;

			function enableSlider() {
				if ( isSlider ) {
					return;
				}

				$factsSlider = $( '<div class="facts-slider owl-carousel" />' );

				$factsContainer.hide().find( '.fact' ).each( function () {
					$factsSlider.append( $( this ).clone() );
				} );

				$factsSlider
					.insertAfter( $factsContainer )
					.on( 'initialized.owl.carousel translated.owl.carousel', function () {
						$factsSlider.find( '.owl-item.active .counter-up' ).counterUp( {
							time: 2000,
							formatter: numberFormatter
						} );
					} )
					.on( 'translate.owl.carousel drag.owl.carousel', function () {
						$factsSlider.find( '.owl-item:not(.active) .counter-up' ).text( '0' );
					} )
					.owlCarousel( {
						loop: true,
						items: 1
					} );

				isSlider = true;
			}

			function disableSlider() {
				if ( ! isSlider ) {
					return;
				}

				$factsSlider.owlCarousel( 'destroy' ).remove();
				$factsSlider = null;

				$factsContainer.show();

				isSlider = false;
			}

			function handler() {
				if ( 1150 >= getViewportWidth() ) {
					enableSlider();
				} else {
					disableSlider();
				}
			}

			handler();
			$( window ).on( 'resize', handler );

			if ( 1 < $factRows.length && 1 === $moreLink.length ) {
				$moreLink.show();
				$factRows.not( ':first' ).hide();

				$moreLink.on( 'click', 'a', function ( event ) {
					var $invisibleRows = $factRows.not( ':visible' );

					if ( 1 === $invisibleRows.length ) {
						$moreLink.remove();
					}

					$invisibleRows.first()
					              .css( 'display', 'table' )
					              .addClass( 'animated fadeInUp' )
					              .find( '.counter-up' )
					              .counterUp( {
						              time: 2000,
						              formatter: numberFormatter
					              } );

					event.preventDefault();
				} );
			}
		} );

		$( '.table-wrap > table' ).each( function () {
			if ( $(this).find("thead") ) {
				$( this )
					.attr( 'data-tablesaw-mode', 'stack' )
					.addClass( 'tablesaw tablesaw-stack' );

				Tablesaw._init( this );
			}
		} );

		$( '.lazy-video-embed' ).on( 'click', '.placeholder', function ( event ) {
			var $placeholder = $( event.currentTarget ),
				embedCode = $( event.delegateTarget ).data( 'embedCode' );

			if ( embedCode ) {
				event.preventDefault();

				$placeholder.replaceWith( embedCode );
			}
		})

		function getViewportWidth() {
			return Math.max( document.documentElement.clientWidth, window.innerWidth || 0 )
		}

		function numberFormatter( value ) {
			return parseInt( value ).toLocaleString( $( 'html' ).attr( 'lang' ) );
		}

		$('.free-contact-icon img').on('mouseenter', function() {
			var newSrc = $(this).attr('data-src'),
				img = $(this);

			img.attr('data-orSrc', img.attr('src'));
			img.attr('src', newSrc);
		}).on('mouseleave', function() {
			var img = $(this);
    	img.attr('src', img.attr('data-orSrc'));
		});

	} );
} )( jQuery );

